"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBestTransferRate = void 0;
const dayjs = require("dayjs");
const _ = require("lodash");
const sortAndGroupTransferRates_1 = require("./sortAndGroupTransferRates");
const tryFindTransferRates_1 = require("./tryFindTransferRates");
const getBestTransferRate = async (supabase, rates, from_area, to_area, via_area, type, date, passengers, margin_discount_percentage = 0, default_historic_price_increase = 5) => {
    const transfer_rates = await (0, tryFindTransferRates_1.tryFindTransferRates)(supabase, rates, from_area, to_area, via_area, type, date);
    const sorted = (0, sortAndGroupTransferRates_1.sortAndGroupTransferRates)(transfer_rates, type, passengers, false);
    // get the cheapest rate by rate_total_price
    const golf_transfer_rate = _.minBy(sorted.rates, "rate_total_price");
    // only add the line if there is a rate
    if (golf_transfer_rate) {
        let margin = golf_transfer_rate.rate_margin;
        let historic_price_increase = 1;
        if (transfer_rates?.historical) {
            if (transfer_rates.offset === 1) {
                historic_price_increase = default_historic_price_increase / 100 + 1;
            }
            if (transfer_rates.offset === 2) {
                historic_price_increase =
                    (default_historic_price_increase / 100) * transfer_rates.offset + 1;
            }
            // apply the margin percentage discount
            if (margin_discount_percentage) {
                const percentage = (100 - margin_discount_percentage) / 100;
                margin = margin * percentage;
            }
        }
        const rate_config = {
            historic_rate: transfer_rates?.historical
                ? {
                    ...golf_transfer_rate,
                    percentage_increase: default_historic_price_increase * transfer_rates.offset,
                    date: dayjs(date)
                        .subtract(transfer_rates.offset, "year")
                        .format("YYYY-MM-DD"),
                }
                : null,
            max_pax: golf_transfer_rate.rate_max_pax,
            rate: {
                ...golf_transfer_rate?.rates,
                type: transfer_rates?.historical
                    ? "CUSTOM"
                    : golf_transfer_rate?.rates?.type,
                estimated: transfer_rates?.historical ? true : false,
            },
            custom: transfer_rates?.historical ? true : false,
            vehicle: golf_transfer_rate?.vehicle,
            outbound_cost: Number((golf_transfer_rate.rate_outbound_cost_price * historic_price_increase).toFixed(0)),
            outbound_margin: Number((golf_transfer_rate.rate_outbound_margin * historic_price_increase).toFixed(0)),
            outbound_price: Number((golf_transfer_rate.rate_outbound_sell_price * historic_price_increase).toFixed(0)),
            outbound_total: Number((golf_transfer_rate.rate_outbound_total_price * historic_price_increase).toFixed(0)),
            inbound_cost: Number((golf_transfer_rate.rate_inbound_cost_price * historic_price_increase).toFixed(0)),
            inbound_margin: Number((golf_transfer_rate.rate_inbound_margin * historic_price_increase).toFixed(0)),
            inbound_price: Number((golf_transfer_rate.rate_inbound_sell_price * historic_price_increase).toFixed(0)),
            inbound_total: Number((golf_transfer_rate.rate_inbound_total_price * historic_price_increase).toFixed(0)),
            cost: Number((golf_transfer_rate.rate_cost_price * historic_price_increase).toFixed(0)),
            margin: Number((margin * historic_price_increase).toFixed(0)),
            price: Number((golf_transfer_rate.rate_cost_price +
                margin * historic_price_increase).toFixed(0)),
            total: Number((golf_transfer_rate.rate_total_price * historic_price_increase).toFixed(0)),
            quantity: golf_transfer_rate.rate_number_of_vehicles,
            vat: golf_transfer_rate.supplier?.offerings?.transfers?.offerings
                ?.transfers?.vat,
            withholding_tax: golf_transfer_rate.supplier?.offerings?.transfers?.offerings?.transfers
                ?.withholding_tax,
        };
        return {
            vehicle: rate_config,
            supplier: {
                id: golf_transfer_rate.supplier.id,
                name: golf_transfer_rate.supplier.name,
                offerings: golf_transfer_rate.supplier.offerings,
                currency: golf_transfer_rate.rate_base_currency,
                notes: "",
            },
        };
    }
    return null;
};
exports.getBestTransferRate = getBestTransferRate;
